/* src/pages/reports/reservas/TotalReservasPage.tsx */
import { useState } from "react";
import dayjs from "dayjs";
import { Stack, TextField, Paper, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import FiltersBar, { Filtros } from "../../../components/ReservasFilterBar";
import { useTotalReservas } from "../../../hooks/useTotalReservas";

export default function TotalReservasPage() {
  const { t } = useTranslation<"translation">();
  const [filtros, setFiltros] = useState<Filtros>({});
  const [desde, setDesde] = useState(dayjs().startOf("month").format("YYYY-MM-DD"));
  const [hasta, setHasta] = useState(dayjs().format("YYYY-MM-DD"));

  const { data: total = 0, isFetching } = useTotalReservas({
    ...filtros,
    desde,
    hasta,
  });

  return (
    <Stack spacing={3}>
      <Typography variant="h5">{t("totalReservas.titulo")}</Typography>

      {/* rango de fechas */}
      <Stack direction="row" spacing={2}>
        <TextField
          type="date"
          label={t("totalReservas.filtros.desde")}
          value={desde}
          onChange={(e) => setDesde(e.target.value)}
        />
        <TextField
          type="date"
          label={t("totalReservas.filtros.hasta")}
          value={hasta}
          onChange={(e) => setHasta(e.target.value)}
        />
      </Stack>

      {/* barra de filtros (sin Profesor ni Cliente) */}
      <FiltersBar value={filtros} onChange={setFiltros} hideProfesor hideCliente />

      {/* resultado */}
      <Paper sx={{ p: 4, textAlign: "center" }}>
        {isFetching ? <CircularProgress /> : <Typography variant="h3">{total}</Typography>}
        <Typography variant="subtitle2">{t("totalReservas.resultado.label")}</Typography>
      </Paper>
    </Stack>
  );
}
